import React from 'react';
import GenericNomenclatureList from './GenericNomenclatureList';
import { useRoomTypeMutations } from '../../../hooks/useNomenclatures';

const RoomTypeList = ({ items, onUpdate }) => {
  const mutations = useRoomTypeMutations();

  const fields = [
    { name: 'requiresIsolation', label: 'Requires Isolation', type: 'boolean' },
    { name: 'highRisk', label: 'High Risk', type: 'boolean' }
  ];

  return (
    <GenericNomenclatureList
      items={items}
      type="room-types"
      title="Room Types"
      fields={fields}
      mutations={mutations}
      onUpdate={onUpdate}
    />
  );
};

export default RoomTypeList;

